import { apiPost, apiGet, postNdjsonStream, type StreamEventCallback } from "./client";

export interface ProposalSession {
  id: string;
  url: string;
  status: string;
  fields?: ProposalField[];
  title?: string;
  createdAt: string;
}

export interface ProposalField {
  id: string;
  type: string;
  label: string;
  required: boolean;
  options?: string[];
  value?: string;
}

export interface ProposalSessionList {
  sessions: ProposalSession[];
}

const PROPOSALS_API = "/api/proposals";

export async function createSession(
  url: string,
  options?: { company?: string; dealName?: string; opportunityId?: string },
): Promise<ProposalSession> {
  return apiPost<ProposalSession>(`${PROPOSALS_API}/session`, {
    url,
    ...options,
  });
}

export async function getSession(sessionId: string): Promise<ProposalSession> {
  return apiGet<ProposalSession>(`${PROPOSALS_API}/session/${sessionId}`);
}

export async function listSessions(): Promise<ProposalSessionList> {
  return apiGet<ProposalSessionList>(`${PROPOSALS_API}/sessions`);
}

export async function prefillAnswers(
  sessionId: string,
  onEvent: StreamEventCallback,
  signal?: AbortSignal,
): Promise<void> {
  return postNdjsonStream(
    `${PROPOSALS_API}/session/${sessionId}/prefill`,
    {},
    onEvent,
    signal,
  );
}

export async function fillForm(
  sessionId: string,
  answers: Record<string, string>,
): Promise<{ steps: unknown[]; sessionId: string }> {
  return apiPost(`${PROPOSALS_API}/session/${sessionId}/fill`, { answers });
}

export async function getHandoffData(
  sessionId: string,
): Promise<{ fields: ProposalField[]; answers: Record<string, string>; screenshotUrl?: string }> {
  return apiGet(`${PROPOSALS_API}/session/${sessionId}/handoff`);
}

export async function closeSession(sessionId: string): Promise<void> {
  await apiPost(`${PROPOSALS_API}/session/${sessionId}/close`);
}
